"use strict";

export default {
	"common": {
		"content": `
			<div class="sparxpres-logo">
				<svg viewBox="0 15 200 19" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
					<g fill="#9B9CA0">
						<path d="M5.4,34c-1.5-0.1-3-0.3-4.3-0.7l0.4-3.3c1.2,0.4,2.9,0.8,4.4,0.9c2.1,0.1,3.7-0.5,3.8-2.2 c0.2-3.5-8.8-2.4-8.5-8.4c0.2-3.3,3.3-5.4,8.4-5.1c1.2,0.1,2.6,0.3,3.8,0.5L13,18.9c-1.2-0.4-2.5-0.6-3.8-0.7 c-2.4-0.1-3.6,0.7-3.7,2c-0.2,3.3,8.8,2.5,8.5,8.3C13.9,31.9,10.6,34.3,5.4,34z"/>
						<path d="M29.6,27.4c-0.4,0-0.9,0-1.4-0.1v6.4h-4.1V15.2c1.7,0,3.6,0,5.7,0c5.2,0,8.1,2.2,8.1,5.8 C37.9,24.6,34.8,27.4,29.6,27.4z M29.7,18.2c-0.5,0-1,0-1.5,0v6.1c0.4,0.1,0.8,0.1,1.2,0.1c2.5,0,4.3-1.2,4.3-3.2 C33.7,19.4,32.4,18.2,29.7,18.2z"/>
						<path d="M81.3,33.7l-5.9-7.6h-0.2v7.6h-4.1l0-18.5c1.6,0,3.5,0,6.1,0c4.7,0,7.8,1.4,7.8,5.2c0,2.7-2.2,4.7-5.4,5.1 c0.6,0.7,6.8,8.2,6.8,8.2H81.3z M76.8,18.1c-0.6,0-1.2,0-1.6,0.1v5.3c0.3,0,0.9,0.1,1.5,0.1c2.5,0,4-1.1,4-2.8 C80.7,18.9,79.4,18.1,76.8,18.1z"/>
						<polygon points="50.5,15.2 55.3,15.2 62.8,33.7 58.1,33.7 52.8,19.8 47.4,33.7 42.9,33.7"/>
						<polygon fill="#BE2B31" points="61.3,30 44.4,30 45.5,27.3 60.2,27.3"/>
						<path d="M106.6,33.5l-4.7-6.5l-4.7,6.5h-4.8l7.3-9l-7-9.2h5l4.6,6.3l4.7-6.3h4.6l-6.8,9l7.3,9.2H106.6z"/>
						<path d="M163.1,33.5V15.3h11.3v3h-7.3v4.4h7v2.9h-7v4.9h7.3v3H163.1z"/>
						<path d="M124.5,27.6c-0.5,0-1.2,0-1.6-0.1v6h-3.8V15.3c1.6,0,3.9-0.1,6-0.1c4.7,0,7.3,2.2,7.3,5.9 C132.4,25.1,129.2,27.6,124.5,27.6z M124.8,18.2c-0.7,0-1.4,0-1.9,0v6.2c0.4,0.1,1.1,0.1,1.6,0.1c2.4,0,3.8-1.1,3.8-3.3 C128.3,19.5,127.1,18.2,124.8,18.2z"/>
						<path d="M188.4,33.9c-1.4,0-3.2-0.3-4.3-0.5l0.4-3.3c1.1,0.4,2.7,0.7,4.4,0.7c1.9,0,3.6-0.8,3.6-2.5 c0-3.2-8.7-1.5-8.7-7.4c0-3.4,2.9-5.6,8.1-5.6c1.1,0,2.9,0.2,4,0.3l-0.4,3.2c-1.1-0.3-2.6-0.5-3.7-0.5c-2.5,0-3.6,0.9-3.6,2.2 c0,3.1,8.8,1.7,8.8,7.4C196.9,31.5,193.5,33.9,188.4,33.9z"/>
						<path d="M150.1,33.5l-5.3-7.5h-0.2v7.5h-3.8V15.3c1.3-0.1,3.8-0.1,6-0.1c4.4,0,6.9,1.7,6.9,5c0,3-2.1,4.8-5,5.2 c0.4,0.5,0.9,1.2,1.5,2l4.6,6.1H150.1z M146.3,18.1c-0.6,0-1.1,0-1.6,0.1v5.2c0.5,0,1.2,0.1,1.8,0.1c2,0,3.3-1.2,3.3-2.9 C149.7,19,148.4,18.1,146.3,18.1z"/>
					</g>
				</svg>
			</div>

			<div class="sparxpres-monthly-payment">
				<div class="sparxpres-headline sparxpres-main-color">Delbetaling</div>
				<div class="sparxpres-headline sparxpres-main-color"><span id="sparxpres-monthly-payments"></span> kr. pr. måned</div>
			</div>

			<div id="sparxpres_web_sale_period" class="sparxpres_web_sale_period"></div>

			<div class="sparxpres-description">
				<div id="sparxpres-compliance-text"></div>
				<div class="sparxpres-compliance-footer">Delbetaling via Sparxpres. <a class="sparxpres-read-more" onclick="window.dispatchEvent(new Event('sparxpresInformationPageOpen'));">Læs mere.</a></div>
			</div>
		`,
		"xprespay": `
			<div class="sparxpres-container">
				<div class="sparxpres-xprespay">
					<a class="sparxpres-xprespay-link" onclick="window.dispatchEvent(new Event('xpresPayInformationPageOpen'));">
						<div class="sparxpres-xprespay-content">
							<div class="sparxpres-xprespay-text">
								Betal med XpresPay
							</div>
							<div class="sparxpres-xprespay-logo">
								<svg viewBox="0 0 487.9 89.2" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
									<rect x="289.6" fill="#be2b31" class="xprespay-pay-bg-color" width="198.4" height="89.2"/>
									<g>
										<path fill="#FFFFFF" d="M325.3,28.7c-1.3,0-2.5,0-3.7,0.1v15.7c1.1,0.1,2.1,0.2,3.1,0.2c6.5-0.1,10.9-3.1,10.9-8.2 C335.6,31.7,332.4,28.7,325.3,28.7 M325.1,52.1c-1,0-2.3,0-3.6-0.1v16.3h-10.5V20.9h14.6c13.4,0,20.8,5.7,20.8,14.9 C346.5,45,338.4,52.1,325.1,52.1"/>
									</g>
									<polygon fill="#9B9CA0" points="36.7,67.5 24.5,50.9 12.4,67.5 0,67.5 18.6,44.4 0.7,20.9 13.5,20.9 25.4,37.1 37.3,20.9 49.1,20.9 31.6,43.9 50.2,67.5 "/>
									<polyline fill="#FFFFFF" points="447.4,43.3 447.4,67.3 436.9,67.3 436.9,43 "/>
									<polyline fill="#FFFFFF" points="438.2,47.3 417.9,20.7 430.8,20.7 442.7,37 454.6,20.7 466.4,20.7 446.7,46.7 "/>
									<polygon fill="#9B9CA0" points="181.5,67.5 181.5,20.9 210.5,20.9 210.5,28.5 191.7,28.5 191.7,39.9 209.6,39.9 209.6,47.2 191.7,47.2 191.7,59.8 210.5,59.8 210.5,67.5 "/>
									<g>
										<path fill="#9B9CA0" d="M83.2,28.4c-1.8,0-3.5,0-4.8,0.1v15.8c1.1,0.3,2.9,0.4,4.2,0.4c6.1,0,9.8-2.9,9.8-8.3 C92.3,31.7,89.3,28.4,83.2,28.4 M82.6,52.3c-1.2,0-3-0.1-4.2-0.2v15.3h-9.8V20.9c4-0.1,9.9-0.3,15.4-0.3c12,0,18.8,5.6,18.8,15.1 C102.8,45.9,94.5,52.3,82.6,52.3"/>
										<path fill="#9B9CA0" d="M246.2,68.4c-3.5,0-8.2-0.8-11-1.4l1.1-8.3c2.9,1.1,6.9,1.8,11.1,1.8c4.7,0,9.3-1.9,9.3-6.5 c0-8.1-22.2-3.9-22.2-18.8c0-8.7,7.4-14.4,20.6-14.4c2.9,0,7.3,0.4,10.1,0.9l-0.9,8.1c-2.7-0.8-6.7-1.3-9.6-1.3 c-6.4,0-9.2,2.3-9.2,5.7c0,7.9,22.5,4.4,22.5,18.8C268,62.3,259.1,68.4,246.2,68.4"/>
										<path fill="#9B9CA0" d="M138.3,28c-1.6,0-2.9,0-4.2,0.2v13.4c1.4,0.1,3,0.2,4.5,0.2c5.2,0,8.5-3,8.5-7.3C147.2,30.3,143.8,28,138.3,28 M148.1,67.5l-13.5-19.2h-0.5v19.2h-9.8V20.9c3.4-0.2,9.6-0.3,15.4-0.3c11.2,0,17.8,4.3,17.8,12.9c0,7.6-5.3,12.2-12.9,13.4 c1.1,1.3,2.4,3,3.8,5l11.7,15.6H148.1z"/>
									</g>
									<polygon fill="#FFFFFF" points="406.3,58.4 363.1,58.4 365.9,51.6 403.6,51.6 "/>
									<polygon fill="#FFFFFF" points="362.2,60.6 359.2,67.9 370.6,67.9 373.5,60.6 "/>
									<polygon fill="#FFFFFF" points="377.8,49.5 384.6,32.4 391.2,49.5 402.7,49.5 390.9,20.5 378.6,20.5 366.7,49.5 "/>
									<polygon fill="#FFFFFF" points="395.4,60.6 398.2,67.9 410.2,67.9 407.2,60.6 "/>
								</svg>
							</div>
						</div>
					</a>
				</div>
			</div>
		`,
	},
	"simple": {
		"header": `
			<div class="sparxpres-container">
		`,
		"footer": `
			</div>
		`
	},
	"modal": {
		"header": `
			<div class="sparxpres-container">
				<span class="sparxpres-modal-open" onclick="document.getElementById('sparxpresWebSaleModal').classList.remove('sparxpres-d-none');">Vis delbetaling</span>
				<div class="sparxpres-modal sparxpres-d-none" id="sparxpresWebSaleModal">
					<div class="sparxpres-modal-content">
						<span class="sparxpres-modal-close" onclick="document.getElementById('sparxpresWebSaleModal').classList.add('sparxpres-d-none');">&times;</span>
		`,
		"footer": `
					</div>
				</div>
			</div>
		`
	}
}
